var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.37256 5.37258 0 12 0C18.6244 0.00714111 23.9928 5.37555 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM2 12C2 17.5228 6.47715 22 12 22C17.5203 21.994 21.9939 17.5203 22 12C22 6.47717 17.5228 2 12 2C6.47715 2 2 6.47717 2 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 12C3.5 7.3056 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.3056 20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12ZM11.75 13H12.75C14.5449 13 16 11.5449 16 9.75C16 7.95508 14.5449 6.5 12.75 6.5H10.5C9.94771 6.5 9.5 6.94769 9.5 7.5V16.5C9.5 17.0523 9.94771 17.5 10.5 17.5C11.0523 17.5 11.5 17.0523 11.5 16.5V13.25C11.5 13.1119 11.6119 13 11.75 13Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 8.5H11.75C11.6119 8.5 11.5 8.61193 11.5 8.75V10.75C11.5 10.8881 11.6119 11 11.75 11H12.75C13.4404 11 14 10.4404 14 9.75C14 9.05964 13.4404 8.5 12.75 8.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/parking.67a2e3f2.svg";
export { ForwardRef as ReactComponent };